import { PopoverRootProps } from '@chakra-ui/react'
import {
  PopoverArrow,
  PopoverBody,
  PopoverCloseTrigger,
  PopoverContent,
  PopoverRoot,
  PopoverTrigger,
} from '@web/components/chakra-ui/popover'
import React from 'react'

type PopoverProps = React.PropsWithChildren<
  PopoverRootProps & {
    triggerEl: React.ReactNode
    hasCloseButton?: boolean
    theme?: 'dark' | 'light'
  }
>

const Popover = ({ triggerEl, children, hasCloseButton = true, theme, ...rest }: PopoverProps) => {
  return (
    <PopoverRoot {...rest}>
      <PopoverTrigger asChild>{triggerEl}</PopoverTrigger>
      <PopoverContent
        width="fit-content"
        {...(theme === 'dark'
          ? { css: { '--popover-bg': '#000', '--chakra-colors-border': '#000' }, color: 'ge.text.inverse' }
          : {})}
      >
        <PopoverArrow />
        {hasCloseButton && <PopoverCloseTrigger />}
        <PopoverBody>{children}</PopoverBody>
      </PopoverContent>
    </PopoverRoot>
  )
}

export { Popover }
